import store from '@/store';
import Queue from 'promise-queue';
import log from '@/configured/logger';
import offlineStore from './store';
import downloadStore from './download-store'
import cacheManager from './cache-manager';
import constants from '@/constants';
import api, {craftError, csrfRequest, jsonToMultiPartFormData} from '@/api';

const maxConcurrent = constants.QUEUE_MAX_CONCURRENCY;
const maxQueue = constants.QUEUE_MAX_TOTAL_ITEMS === -1 ? Infinity : constants.QUEUE_MAX_TOTAL_ITEMS;

let isRunning = false;
let runAgainAfterFinish = false;

const exports = {
  namespace: 'offlineQueue',
  module: {
    namespaced: true,
    state     : {
      queue: []
    },
    mutations : {
      APPEND_QUEUE_ITEM: (state, item) => state.queue.push(item),
      REMOVE_QUEUE_ITEM: (state, item) => state.queue.splice(state.queue.indexOf(item), 1)
    },
    actions   : {
      runQueue,
      addQueueItem,
      queueFinished,
      resetQueue
    },
    getters   : {
    }
  }
};

store.registerModule(exports.namespace.split('/'), exports.module);

export default exports;

//////////

function runQueue({ commit, state }) {

  if(isRunning && !runAgainAfterFinish) {
    runAgainAfterFinish = true;
    return;
  }else if(isRunning) {
    return;
  }else if(state.queue.length === 0) {
    return;
  }else if(!store.state[offlineStore.namespace].isOnline) {
    return;
  }

  isRunning = true;
  const queue = new Queue(maxConcurrent, maxQueue);
  log.info('Queue starting', state.queue);

  state.queue.forEach((queueItem)=>{
    if(queueItem.action === 'pingApi'){

      api
        .post(queueItem.params.url)
        .then((result) => {
          if(craftError(result.data)) {
            log.error('Queue item failed from api error', queueItem, result);
            commit('REMOVE_QUEUE_ITEM', queueItem);
          }else {
            commit('REMOVE_QUEUE_ITEM', queueItem);
          }
        }, (error) => {
          log.error('Queue item failed', queueItem, error);
          if(store.state[offlineStore.namespace].isOnline) {
            commit('REMOVE_QUEUE_ITEM', queueItem);
          }
        })
        .then(()=> {
          // Always
          if((queue.getQueueLength() === 0) && (queue.getPendingLength() === 0)) {
            store.dispatch(`${exports.namespace}/queueFinished`);
          }
        });

    }else if(typeof queueItem.action === 'function') {


      log.warn('Offline queue does not support function. Offline storage removes them once the browser is reloaded.');
      commit('REMOVE_QUEUE_ITEM', queueItem);
      if((queue.getQueueLength() === 0) && (queue.getPendingLength() === 0)) {
        store.dispatch(`${exports.namespace}/queueFinished`);
      }

    }else {

      log.error('Unrecognized offline queue item type', queueItem);
      commit('REMOVE_QUEUE_ITEM', queueItem);
      if((queue.getQueueLength() === 0) && (queue.getPendingLength() === 0)) {
        store.dispatch(`${exports.namespace}/queueFinished`);
      }

    }
  });
}

function resetQueue({commit}) {
  runAgainAfterFinish = false;
  isRunning = false;
}

function queueFinished({commit, state}) {
  if(runAgainAfterFinish) {
    isRunning = false;
    runAgainAfterFinish = false;
    store.dispatch(`${exports.namespace}/runQueue`);
  }else {
    isRunning = false
  }
}

function addQueueItem({ commit }, queueItem) {
  queueItem.uuid = new Date().getTime() + '-' + Math.ceil(10000000 * Math.random());
  commit('APPEND_QUEUE_ITEM', queueItem);
  store.dispatch(`${exports.namespace}/runQueue`);
}
